import { getRequest, postRequest } from "../../../api/api";

export function getRetrieveDeclaration(callbackResponse) {
    return getRequest(
        'api/v1/first-time-login/retrieve-declaration',
        null,
        callbackResponse
    );
}

export function getFirstTimeOptions(callbackResponse) {
    return getRequest(
        'api/v1/first-time-login/first-step-options',
        null,
        callbackResponse
    );
}

export function postSubmitBankAccForm(values, callbackResponse) {
    return postRequest(
        'api/v1/first-time-login/bank-account-setup',
        null,
        values,
        callbackResponse
    );
}

export function postSubmitWealthDeclarationForm(values, callbackResponse) {
    return postRequest(
        'api/v1/first-time-login/wealth-declaration',
        null,
        values,
        callbackResponse
    )
}

export function postSubmitAgreeTermsForm(values, callbackResponse) {
    return postRequest(
        'api/v1/first-time-login/agree-terms',
        null,
        values,
        callbackResponse
    )
}
